<template>
  <section>
    <BanksList v-on:sessionStarted="isCancelDisabled = true" />

    <Modal :isShow="isAuth" size="sm" :accept-text="$t('banksPage.acceptCloseSession')"
      :cancel-text="$t('banksPage.cancelCloseSession')" v-on:close="handleCancel" v-on:accept="handleAccept">
      <div class="px-3 pt-4">
        <Loader class="mx-auto" v-if="loading" />
        <span class="lead d-block text-center" v-else>{{ $t('banksPage.exitModalText') }}</span>
      </div>
    </Modal>

    <BanksListLoadingModal v-if="!isAuth && isPendingAuth && !authorizationId" :cancel-disabled="isCancelDisabled" />
    <Modal v-if="!isAuth && authorizationId" :isShow="!!authorizationId" :isShowFooter="false" :isBackClickable="false" size="lg">
      <div class="consent-modal-content">
        <enablebanking-consent v-if="authorizationId" id="enablebanking-consent" :authorization="authorizationId"
          :origin="BROKER_ORIGIN" :sandbox="SANDBOX" :locale="$i18n.locale || 'en'" can-cancel
          @confirmed="handleConsentConfirmed" @cancelled="handleConsentCancelled"></enablebanking-consent>
      </div>
    </Modal>
  </section>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import BanksList from '@/components/Banks/BanksList'
import BanksListLoadingModal from '@/components/Banks/BanksListLoadingModal'
import { sessionStatuses } from '../constants'
import { BROKER_ORIGIN, SANDBOX } from '../constants'
import { SET_AUTHORIZATION_ID } from '../store/modules/auth/variables'
import Modal from '../components/elements/Modal.vue'

export default {
  name: 'Banks',
  data() {
    return {
      isCancelDisabled: false,
      BROKER_ORIGIN: BROKER_ORIGIN,
      SANDBOX: SANDBOX
    }
  },
  components: {
    BanksList,
    BanksListLoadingModal,
    Modal
  },
  computed: {
    ...mapGetters('auth', ['isAuth', 'loading', 'sessionStatus', 'authorizationId']),
    isPendingAuth() {
      return this.sessionStatus === sessionStatuses.Pending
    }
  },
  mounted() {
    this.getSessionStatus()
  },
  methods: {
    ...mapMutations('auth', [SET_AUTHORIZATION_ID]),
    ...mapActions('auth', ['closeSession', 'getSessionStatus']),
    ...mapActions('personal', ['wipeAllData']),
    clearAuthorizationId() {
      this[SET_AUTHORIZATION_ID](null)
    },
    handleCancel() {
      this.$router.push({ name: 'account' })
    },
    handleAccept() {
      this.closeSession().then(() => { this.wipeAllData() })
    },
    handleConsentCancelled() {
      this.closeSession().then(() => { this.wipeAllData() })
      this.clearAuthorizationId()
    },
    handleConsentConfirmed() {
      this.clearAuthorizationId()
    }
  }
}
</script>

<style lang="scss">
.consent-modal-content {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 3rem;
  min-height: 100%;

  #enablebanking-consent {
    margin-left: 5%;
    margin-right: 5%;
    .tilisy-confirmation {
      margin-top: 3rem;
    }

    .tilisy-about {
      margin-top: 3rem;
      font-size: 0.85rem !important;
    }
  }
}
</style>